export enum PaymentStatus {
  REQUESTED = 'REQUESTED' ,
  APPROVED = 'APPROVED',
  PROCESSING = 'PROCESSING',
  PROCESSED = 'PROCESSED',
  PROCESSED_OFFLINE = 'PROCESSED_OFFLINE',
  PROCESSING_ERROR = 'PROCESSING_ERROR',
  REJECTED = 'REJECTED'
}
